/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_No_TeamsInputs */

const th_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โรงเรียนนี้ยังไม่มีทีม`)
};

const en_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No teams at this school yet.`)
};

const ja_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この学校にはまだチームがありません。`)
};

const zh_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这所学校还没有球队。`)
};

const es_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay equipos en este centro.`)
};

const pt_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum time nesta escola ainda.`)
};

const id_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada tim di sekolah ini.`)
};

const fr_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune équipe dans cet établissement.`)
};

const tl_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang team sa paaralang ito.`)
};

const vi_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trường này chưa có đội nào.`)
};

const ko_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 학교에 아직 팀이 없습니다.`)
};

const de_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Teams an dieser Schule.`)
};

const ru_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В этой школе пока нет команд.`)
};

const tr_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu okulda henüz takım yok.`)
};

const it_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna squadra in questa scuola.`)
};

const pl_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W tej szkole nie ma jeszcze drużyn.`)
};

const uk_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У цій школі поки немає команд.`)
};

const hi_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस स्कूल में अभी कोई टीम नहीं है।`)
};

const ar_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد فرق في هذه المدرسة بعد.`)
};

const ms_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pasukan di sekolah ini.`)
};

const bn_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই স্কুলে এখনও কোনও দল নেই।`)
};

const zh_tw2_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這所學校還沒有球隊。`)
};

const zh_hk2_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這所學校還沒有球隊。`)
};

const ur_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس اسکول میں ابھی کوئی ٹیم نہیں۔`)
};

const fa_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز تیمی در این مدرسه نیست.`)
};

const sw_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna timu shuleni hapa bado.`)
};

const nl_org_no_teams = /** @type {(inputs: Org_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen teams op deze school.`)
};

/**
* | output |
* | --- |
* | "No teams at this school yet." |
*
* @param {Org_No_TeamsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_no_teams = /** @type {((inputs?: Org_No_TeamsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_No_TeamsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_no_teams(inputs)
	if (locale === "ja") return ja_org_no_teams(inputs)
	if (locale === "zh") return zh_org_no_teams(inputs)
	if (locale === "es") return es_org_no_teams(inputs)
	if (locale === "pt") return pt_org_no_teams(inputs)
	if (locale === "id") return id_org_no_teams(inputs)
	if (locale === "fr") return fr_org_no_teams(inputs)
	if (locale === "tl") return tl_org_no_teams(inputs)
	if (locale === "vi") return vi_org_no_teams(inputs)
	if (locale === "ko") return ko_org_no_teams(inputs)
	if (locale === "de") return de_org_no_teams(inputs)
	if (locale === "ru") return ru_org_no_teams(inputs)
	if (locale === "tr") return tr_org_no_teams(inputs)
	if (locale === "it") return it_org_no_teams(inputs)
	if (locale === "pl") return pl_org_no_teams(inputs)
	if (locale === "uk") return uk_org_no_teams(inputs)
	if (locale === "hi") return hi_org_no_teams(inputs)
	if (locale === "ar") return ar_org_no_teams(inputs)
	if (locale === "ms") return ms_org_no_teams(inputs)
	if (locale === "bn") return bn_org_no_teams(inputs)
	if (locale === "zh-TW") return zh_tw2_org_no_teams(inputs)
	if (locale === "zh-HK") return zh_hk2_org_no_teams(inputs)
	if (locale === "ur") return ur_org_no_teams(inputs)
	if (locale === "fa") return fa_org_no_teams(inputs)
	if (locale === "sw") return sw_org_no_teams(inputs)
	if (locale === "nl") return nl_org_no_teams(inputs)
	return en_org_no_teams(inputs)
});